import React, { Component } from 'react';
import { IHomePageBoxSurveyProps } from '../../models/components/homepage-box-survey';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import { Redirect } from 'react-router-dom';
import * as Actions from '../../store/actions/profile';
import { IProfileProps } from '../../models/pages/profile';
import Translator from '../../core/i18n';
import Loading from '../loading/loading';
import ContentLoader from 'react-content-loader';
import { IPreference } from '../../models/action/profile';
import * as SurveyActions from '../../store/actions/survey';
import { Common } from '../../core/common';
import Moment from 'moment';
import * as SurveyPageActions from '../../store/actions/survey';
import CSurveyQuestionsModal from '../../components/lesson/activity-cards/survey/modal';
import { Formik, FormikActions, FormikProps } from 'formik';
import { IResponseData } from '../../models/components/activity-card-survey';
import { responseSurvey } from '../../store/actions/survey';
import { SurveyType } from '../../models/enums/SurveyType';
import { Notification } from '../../components/notification/main';
import { SurveyQuestionType } from '../../models/enums/SurveyQuestionType';
import CSurveyQuestionsGeneralTypeModal from '../lesson/activity-cards/survey/generalTypeModal';
import { Dispatch } from 'redux';
import { validateSurveyResponses } from '../../helpers/surveyHelpers';

const _lodash = require('lodash');
let _common: Common = new Common();

const T = Translator.create();
const _logger = Log.create('Homepage Box Survey');
export class CSurvey extends Component<IHomePageBoxSurveyProps & IProfileProps> {
    state = {
        redirect: false,
        redirectUrl: '/',
        boxItems: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
        boxItemsVisual: [false, false, false, false, false, false],
        boxCount: 0,
        isModalOpen: false,
        isSubmitting: false,
    };

    public handleChange = () => {
        const { userPreferences, dispatch } = this.props;
        const { boxItems, boxItemsVisual } = this.state;

        const updateBoxItemsVisual = (items: string[]) => {
            items.forEach(item => {
                boxItemsVisual[parseInt(item, 10)] = true;
            });
        };

        const updatePreferences = (items: string[]) => {
            const preferencesValue = items.toString();
            const preferenceData = {
                preferences: [{ name: 'home.index.boxallowed', value: preferencesValue }]
            };
            dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
        };

        if (userPreferences && userPreferences.length > 0) {
            const preference = userPreferences.find((pref: any) => pref.name === 'home.index.boxallowed');
            if (preference && preference.value) {
                const updatedBoxItems = preference.value.split(',').filter(item => item !== '8');
                this.setState({ boxItems: updatedBoxItems });
                updateBoxItemsVisual(updatedBoxItems);
                updatePreferences(updatedBoxItems);
            }
        } else {
            const updatedBoxItems = boxItems.filter(item => item !== '8');
            this.setState({ boxItems: updatedBoxItems });
            updateBoxItemsVisual(updatedBoxItems);
            updatePreferences(updatedBoxItems);
        }
    };

    public async onSurveyClick(params: any, index: number) {
        this.props.dispatch(SurveyPageActions.GetGeneralSurveyById(params.surveyId, 'getGeneralSurveyById', 'get'));
        this.triggerModal();
    }

    triggerModal = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    callBackFunction = () => {
        this.props.triggerSurveyModal();
    }

    onClickNavigateUrl = (surveyId?: string, tabIndex?: number) => (event: any) => {
        let url = 'u/Survey/Index';
        if (surveyId && tabIndex) {
            url = url + '?surveyId=' + surveyId + '&tabIndex=' + tabIndex;
        }
        this.setState({ redirect: true, redirectUrl: url });
    }

    componentDidMount() {
        if (this.props.userPreferences!.length > 0) {
            if (this.props.userPreferences!.find((pref: any) => pref.name === 'home.index.boxcount')) {
                this.setState({
                    boxCount: (this.props.userPreferences!.find((pref: any) => pref.name === 'home.index.boxcount') as IPreference).value
                });
            }
        }
    }

    onSubmit = (values: any, formikActions: FormikActions<any>) => {

        const { surveyInfo } = this.props.selectedGeneralSurvey;
        const { userResponses } = values;

        const isError = validateSurveyResponses(surveyInfo, userResponses);

        if (isError) {
            Notification.setNotification('error', T.t('r_survey_unresponded_questions_error'), 'topRight');
        } else {
            if (
                this.props.selectedGeneralSurvey!.surveyInfoId &&
                this.props.selectedGeneralSurvey!.targetList[0].contextType &&
                this.props.selectedGeneralSurvey!.targetList[0].contextId
            ) {
                this.setState({ isSubmitting: true });
                this.props.dispatch(
                    responseSurvey(
                        values.userResponses,
                        this.props.selectedGeneralSurvey!.surveyInfoId,
                        this.props.selectedGeneralSurvey!.targetList[0].contextType,
                        this.props.selectedGeneralSurvey!.targetList[0].contextId,
                        '',
                        '',
                        '',
                        SurveyType.General,
                        (value: any) => {
                            if (value) {
                                formikActions.setFieldValue('isResponded', true);
                                this.triggerModal();
                                this.props.dispatch(SurveyPageActions.getSurveysAction('4', 'getHomeBoxSurvey', 'get', 15, 0, undefined, undefined, true));
                                this.setState(this.state);
                                Notification.setNotification('success', T.t('r_survey_sent_successfully'), 'topRight');
                            }
                        },
                        this.props.selectedGeneralSurvey!.surveyInfo!.questionList.filter((q: any) => q.questionType !== SurveyQuestionType.Heading).length
                    )
                );

            }
        }
    };

    public render() {
        const initialFormValues: IResponseData = {
            userResponses: [],
            isResponded: this.props.surveyInfo ? this.props.surveyInfo.isResponded : false,
            questionIndex: 0
        };

        const loadingSpaces = 74;
        const loadingSizes = this.state.boxCount === 2 ? '0 0 540 300' : '0 0 350 300';
        if (this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
        }

        return (
            <div className="white-box student-discussions ">
                <div className="d-flex justify-content-between white-box-header">
                    <div>
                        <span className='bodytext1 fw-500' tabIndex={0}>
                            {T.t('r_home_index_box_survey')}
                            <span className='badge badge-pill badge-light py-1 px-2' style={{ marginInlineStart: "0.5rem" }} tabIndex={0}>{this.props.surveys ? this.props.surveys.length : ''}</span>
                        </span>
                    </div>
                    <div className="align-self-center">
                        <i
                            className="material-icons mr-2 align-middle"
                            onClick={this.handleChange}
                            style={{ cursor: 'pointer' }}
                        >
                            visibility
                        </i>
                        <a onClick={this.onClickNavigateUrl()}>
                            {T.t('r_menu_course_allOf')}
                            <i className="material-icons ml-2 align-middle">arrow_forward</i>
                        </a>
                    </div>
                </div>
                <Loading spinnerId={'getHomeBoxSurvey'}>
                    <div style={{ backgroundColor: '#fbfaf6' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox={loadingSizes}
                            style={{ width: '100%' }}
                        >
                            <rect x="16" y="24" rx="5" ry="5" width="22" height="28" />
                            <rect x="54" y="24" rx="3" ry="3" width="150" height="13" />
                            <rect x="54" y="47" rx="3" ry="3" width="70" height="9" />

                            <rect x="16" y={24 + loadingSpaces} rx="5" ry="5" width="22" height="28" />
                            <rect x="54" y={24 + loadingSpaces} rx="3" ry="3" width="150" height="13" />
                            <rect x="54" y={47 + loadingSpaces} rx="3" ry="3" width="70" height="9" />

                            <rect x="16" y={24 + loadingSpaces * 2} rx="5" ry="5" width="22" height="28" />
                            <rect x="54" y={24 + loadingSpaces * 2} rx="3" ry="3" width="150" height="13" />
                            <rect x="54" y={47 + loadingSpaces * 2} rx="3" ry="3" width="70" height="9" />

                            <rect x="16" y={24 + loadingSpaces * 3} rx="5" ry="5" width="22" height="28" />
                            <rect x="54" y={24 + loadingSpaces * 3} rx="3" ry="3" width="150" height="13" />
                            <rect x="54" y={47 + loadingSpaces * 3} rx="3" ry="3" width="70" height="9" />

                            <rect x="16" y={24 + loadingSpaces * 4} rx="5" ry="5" width="22" height="28" />
                            <rect x="54" y={24 + loadingSpaces * 4} rx="3" ry="3" width="150" height="13" />
                            <rect x="54" y={47 + loadingSpaces * 4} rx="3" ry="3" width="70" height="9" />
                        </ContentLoader>
                    </div>
                </Loading>
                <ul id="getHomeBoxSurvey_Content" className="white-box-body">
                    {this.props.surveys && this.props.surveys.length > 0 ? (
                        this.props.surveys.map((survey: any, index: any) =>

                            <li onClick={this.onSurveyClick.bind(this, survey, index)} key={index} className="media mb-3">
                                <img className="notes-icon" src={_common.GetActivityTypeIcons('survey')} alt="Activity Type Icon" />
                                <div className={"media-body" + (!_common.isArabic((survey.name) ? survey.name : '', document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>
                                    <h5 className="mt-0 homebox-clickable-item" tabIndex={0}
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                this.onSurveyClick(survey, index)
                                            }
                                        }}
                                    >{survey.name}</h5>
                                    <span tabIndex={0}>
                                        <div id="surveyBody" className="survey-body">
                                            <span style={{ lineHeight: 1.145 }} dangerouslySetInnerHTML={{ __html: (survey.body) ? (survey.body.length > 180) ? survey.body.slice(0, 180).replace(/<\/?[^>]+(>|$)/g, '') + ' ...' : survey.body.replace(/<\/?[^>]+(>|$)/g, '') : '' }} />
                                        </div>
                                    </span>
                                    <i tabIndex={0}>{Moment(survey.createdDate).format(_common.findDateFormat(this.props.userPreferences!, true))}</i>
                                </div>
                            </li>

                        )
                    ) : (
                        <p tabIndex={0}>{T.t('r_home_box_survey_not_found')}</p>
                    )}
                </ul>
                {this.props.isSimulate && this.state.isModalOpen && this.props.selectedGeneralSurvey && this.props.selectedGeneralSurvey!.surveyInfo ? (
                    <Formik initialValues={initialFormValues} onSubmit={this.onSubmit}>
                        {formik => {
                            return (
                                <CSurveyQuestionsGeneralTypeModal
                                    isModalOpen={this.state.isModalOpen}
                                    triggerModal={this.triggerModal}
                                    questionList={this.props.selectedGeneralSurvey!.surveyInfo!.questionList}
                                    surveyName={this.props.selectedGeneralSurvey!.name}
                                    surveyId={this.props.selectedGeneralSurvey!.surveyInfoId}
                                    formik={formik}
                                    onSubmit={this.onSubmit}
                                    isSubmitting={this.state.isSubmitting} />
                            );
                        }}
                    </Formik>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHomePageBoxSurveyProps): IHomePageBoxSurveyProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHomePageBoxSurveyProps = Object.assign({}, ownProps, {
        surveys: state.survey.homePageSurveys,
        userPreferences: state.profile.userPreferences.preferences,
        userType: state.login.identitiy.userType,
        selectedGeneralSurvey: state.survey.selectedGeneralSurvey
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.profile.userPreferences === prev.profile.userPreferences &&
        next.survey.homePageSurveys === prev.survey.homePageSurveys &&
        next.survey.selectedSurvey === prev.survey.selectedSurvey &&
        next.survey.selectedGeneralSurvey === prev.survey.selectedGeneralSurvey
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const Survey = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual,
    }
)(CSurvey);

export default Survey;
